function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M199.5,100.5 L199.5,199.5 L100.5,199.5 L100.5,120 C100.5,114.615224 102.682612,109.740224 106.211418,106.211418 C109.740224,102.682612 114.615224,100.5 120,100.5 L120,100.5 L199.5,100.5 Z",
  stroke: "#073C50"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "118 152 158 152 158 158 118 158"
});

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "118 163 183 163 183 169 118 169"
});

var _ref5 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#DEDEDE",
  points: "118 174 138 174 138 180 118 180"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  fill: "#E2FCA4",
  cx: 128.5,
  cy: 66.5,
  r: 17.5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  stroke: "#073C50",
  cx: 128,
  cy: 66,
  r: 22.5
});

var _ref8 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "121.416667 59.4166667 121.416667 62.1883159 130.64057 62.1883159 121.439632 71.3892545 123.610975 73.560598 132.811684 64.3596594 132.811684 73.5833333 135.583333 73.5833333 135.583333 62.1883159 135.583333 59.4166667"
});

var _ref9 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "123 117 179 117 179 123 123 123"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M151,91 C163.702549,91 174,101.297451 174,114 C174,116.813407 173.494858,119.508833 172.570325,122.000526 L129.429675,122.000526 C128.505142,119.508833 128,116.813407 128,114 C128,101.297451 138.297451,91 151,91 Z",
  fill: "#FFFFFF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M151,91.5 C157.213203,91.5 162.838203,94.0183983 166.909903,98.0900974 C170.981602,102.161797 173.5,107.786797 173.5,114 C173.5,117.007939 172.909899,119.878059 171.838895,122.500785 L171.838895,122.500785 L130.161105,122.500785 C129.090101,119.878059 128.5,117.007939 128.5,114 C128.5,107.786797 131.018398,102.161797 135.090097,98.0900974 C139.161797,94.0183983 144.786797,91.5 151,91.5 Z",
  stroke: "#073C50"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M151.5,97 C161.164983,97 169,104.835017 169,114.5 C169,117.184324 168.395624,119.727488 167.315523,122.00084 L135.684477,122.00084 C134.604376,119.727488 134,117.184324 134,114.5 C134,104.835017 141.835017,97 151.5,97 Z",
  fill: "#E2FCA4"
});

var _ref13 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "144.416667 107.416667 144.416667 110.188316 153.64057 110.188316 144.439632 119.389255 146.610975 121.560598 155.811684 112.359659 155.811684 121.583333 158.583333 121.583333 158.583333 110.188316 158.583333 107.416667"
});

var _ref14 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "95 199 205 199 205 207 95 207"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M244,100 L252,100 C258.627417,100 264,105.372583 264,112 L264,120 C264,126.627417 258.627417,132 252,132 L232,132 L232,112 C232,105.372583 237.372583,100 244,100 Z",
  fill: "#073C50"
});

var _ref16 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "253 113.508741 251.543126 112 246.712284 117.002758 244.456874 114.667085 243 116.175825 246.712284 120"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M72,159 L56,159 C51.581722,159 48,162.581722 48,167 L48,183 C48,187.418278 51.581722,191 56,191 L80,191 L80,167 C80,162.581722 76.418278,159 72,159 Z",
  fill: "#E2FCA4"
});

var _ref18 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "67.363708 170 69 171.636292 65.636 175 69 178.363708 67.363708 180 63.999 176.636 60.636292 180 59 178.363708 62.363 175 59 171.636292 60.636292 170 64 173.363"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M52,111.5 C54.0710678,111.5 55.9460678,112.339466 57.3033009,113.696699 C58.6605339,115.053932 59.5,116.928932 59.5,119 L59.5,119 L59.5,134.5 L44,134.5 C41.9289322,134.5 40.0539322,133.660534 38.6966991,132.303301 C37.3394661,130.946068 36.5,129.071068 36.5,127 L36.5,127 L36.5,119 C36.5,116.928932 37.3394661,115.053932 38.6966991,113.696699 C40.0539322,112.339466 41.9289322,111.5 44,111.5 L44,111.5 Z",
  stroke: "#073C50"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9999857,129.312497 C51.2101145,129.312497 53.8124718,126.710139 53.8124718,123.500011 C53.8124718,120.289882 51.2101373,117.687525 47.9999857,117.687525 C44.7898569,117.687525 42.1874996,120.289859 42.1874996,123.500011 C42.1874996,126.710162 44.7898569,129.312497 47.9999857,129.312497 Z M51.5340044,125.973348 L45.5266258,119.966015 C47.1720305,118.809249 49.5163014,118.917556 51.049394,120.450602 C52.5833106,121.984542 52.6900151,124.329065 51.5340044,125.973348 Z M44.9505774,126.549419 C43.4166607,125.01548 43.3099563,122.670957 44.465967,121.026674 L50.4733456,127.034007 C48.8279638,128.190773 46.48367,128.082489 44.9505774,126.549419 Z",
  fill: "#073C50",
  fillRule: "nonzero"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M236,156.5 C238.071068,156.5 239.946068,157.339466 241.303301,158.696699 C242.660534,160.053932 243.5,161.928932 243.5,164 L243.5,164 L243.5,172 C243.5,174.071068 242.660534,175.946068 241.303301,177.303301 C239.946068,178.660534 238.071068,179.5 236,179.5 L236,179.5 L220.5,179.5 L220.5,164 C220.5,161.928932 221.339466,160.053932 222.696699,158.696699 C224.053932,157.339466 225.928932,156.5 228,156.5 L228,156.5 Z",
  stroke: "#073C50"
});

var _ref22 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#073C50",
  points: "227 167 237 167 237 170 227 170"
});

var SvgArtDeposit = function SvgArtDeposit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 300 250",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArtDeposit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/art-deposit.23216ffd.svg";
export { ForwardRef as ReactComponent };